var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHolidayVillage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1368_5802",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 53,
    height: 53
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 53,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1368_5802)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.68262 41.9583V23.0176L20.7243 11.976L31.766 23.0176V41.9583H9.68262ZM11.891 39.75H19.0256V34.6538H22.423V39.75H29.5576V23.9052L20.7243 15.0719L11.891 23.9052V39.75ZM19.0256 28.1987V24.8013H22.423V28.1987H19.0256ZM35.3333 42.0008V21.5355L25.7737 11.976H28.9121L37.5416 20.6055V42.0008H35.3333ZM41.109 42.0008V19.1233L33.9616 11.976H37.1425L43.3173 18.1932V42.0008H41.109Z",
    fill: "#FFBA69"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHolidayVillage);
export default __webpack_public_path__ + "static/media/holiday_village.711e97c672570c74bf88af0d7bbaef09.svg";
export { ForwardRef as ReactComponent };